<template>
 <div class="product-intro-section">
   <div class="main-container">
     THESE ARE OUR PRODUCTS.
   </div>
 </div>
</template>

<script>
 export default {
  name: 'ProductIntroSection',

 }
</script>

<style lang="scss">
@import "ProductIntroSection.scss";
</style>
